import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { PRODUCTS } from '#/products/config';

const shortcutProducts = [PRODUCTS['DO']!, PRODUCTS['EH']!, PRODUCTS['XA']!];

const options = shortcutProducts.map((p) => ({
  value: p.code,
  label: p.code,
}));

export default function productShortcutView(
  selectedProductCode: State['productCode'],
) {
  const selectedOption =
    options.find((option) => option.value === selectedProductCode) ?? null;

  return { options, selectedOption };
}
